import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export const PURCHASE_KEYS = 'PURCHASE_KEYS';
export const TRANSFER_KEYS = 'TRANSFER_KEYS';

@Component({
    selector: 'app-dlg-store-access-key',
    templateUrl: './dlg-store-access-key.component.pug',
    styleUrls: ['./dlg-store-access-key.component.less'],
})
export class DlgStoreAccessKeyComponent implements OnInit {
    @HostBinding('class.effect--grayscale') disabled: boolean = false;

    constructor(
        public _dialogRef: MatDialogRef<DlgStoreAccessKeyComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        // This is hack to close by backdrop.
        const overlayWrapper = this._dialogRef['_overlayRef'].overlayElement.parentElement;

        overlayWrapper.addEventListener('click', ({ target }) => {
            if (overlayWrapper !== target) {
                return;
            }

            this.onClose();
        });
    }

    onClose() {
        this.data.close();
    }

    onTransfer(payload: any) {
        this.data.transfer(payload);
    }
}
